import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    q: 'Is it safe to use every day?',
    a: 'Yes. DryControl is formulated with natural, transdermally active ingredients designed for continuous use. It contains no hormones, no steroids, and no parabens. Because it bypasses the digestive system, it is gentle on the stomach and liver.'
  }, {
    q: 'How exactly does a patch help my bladder?',
    a: 'The patch delivers active compounds directly through the skin to support the nerve-muscle communication layer. Instead of just trying to strengthen the pelvic floor muscle (like Kegels do), it helps ensure the signal telling that muscle to contract arrives on time when you sneeze, cough, or laugh.'
  }, {
    q: 'When will I start seeing results?',
    a: "Most women notice their first 'non-event' (a sneeze or cough without a leak) between days 4 and 7. By week two, the constant urgency and anxiety typically begin to fade. We recommend the 90-day supply because full nerve pathway support builds cumulatively over time."
  }, {
    q: 'Does this interfere with HRT or other medications?',
    a: 'DryControl is hormone-free and non-systemic in the way oral medications are. However, if you are on specific prescription medications for overactive bladder or have complex medical conditions, we always recommend showing the ingredient list to your GP.'
  }, {
    q: 'Will my GP approve of this?',
    a: "Many GPs are simply unaware of transdermal nerve support because it is not on the standard NHS prescribing pathway (which focuses on pads and physiotherapy first). However, doctors generally support safe, non-invasive approaches that improve a patient's quality of life."
  }, {
    q: "What if it doesn't work for me?",
    a: "We offer a 90-day, no-questions-asked money-back guarantee. If you don't experience a significant improvement in your quality of life, simply email us. We will refund your entire order, including the boxes you've already used. You carry zero financial risk."
  }, {
    q: 'How do I apply it?',
    a: 'Apply one patch to a clean, dry, relatively hairless area of skin (like the lower abdomen, hip, or upper arm). Leave it on for 24 hours, then replace it with a new one. You can shower and bathe normally while wearing it.'
  }];
  return <section className="bg-offwhite py-16 md:py-24 px-5" data-id="element-100">
      <div className="max-w-[780px] mx-auto" data-id="element-101">
        <div className="text-center mb-12" data-id="element-102">
          <h2 className="font-playfair text-[28px] md:text-[32px] text-ink font-semibold" data-id="element-103">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-2" data-id="element-104">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="flex flex-col" data-id="element-105">
                <button onClick={() => setOpenIndex(isOpen ? -1 : index)} className={`flex items-center justify-between w-full text-left bg-white border border-divider p-4 md:px-5 md:py-4 transition-colors ${isOpen ? 'rounded-t-lg border-b-0' : 'rounded-lg hover:bg-cream'}`} data-id="element-106">
                  <span className="font-inter font-semibold text-[15px] text-ink pr-4" data-id="element-107">
                    {faq.q}
                  </span>
                  <span className="shrink-0 text-forest" data-id="element-108">
                    {isOpen ? <Minus className="w-5 h-5" data-id="element-109" /> : <Plus className="w-5 h-5" data-id="element-110" />}
                  </span>
                </button>

                <AnimatePresence data-id="element-111">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} className="overflow-hidden" data-id="element-112">
                      <div className="bg-cream rounded-b-lg p-4 md:px-5 md:py-4 border border-t-0 border-divider" data-id="element-113">
                        <p className="font-inter text-[15px] text-secondary leading-[1.7]" data-id="element-114">
                          {faq.a}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}